import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Constant } from '../constants/constant';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class DeliverySlotsService {


  url = environment.serverAPI4 + "/api/days";
  url1 = environment.serverAPI4 + "/api/ig/days";

  constructor(private http: HttpClient, private userService: UserService) { }


  getAllDeliverySlotsDropDown(): Observable<Object> {
    let guestLoginEnabled = localStorage.getItem(Constant['GUEST_LOGIN'])
    let authourized = this.userService.getAuthenticatedUser();
    if (guestLoginEnabled == "0" || authourized) {
      return this.http.get(`${this.url}/dropdown`);
    } else {
      return this.http.get(`${this.url1}/dropdown`);
    }

  }

}
